<template>
  <div class="checkout-input" :class="{ 'checkout-input--active': model }">
    <label class="checkout-input__label">
      <input
        v-model="model"
        type="radio"
        :name="name"
        :value="value"
        class="base-radio checkout-input__input"
        required
      />

      <span class="checkout-input__label-wrapper">
        <slot name="label"></slot>
      </span>
    </label>

    <div :class="bodyClasses">
      <div class="checkout-input__description">
        <slot name="description"></slot>
      </div>

      <template v-if="useVShow">
        <div v-show="model" class="checkout-input__form">
          <slot name="form"></slot>
        </div>
      </template>

      <template v-else>
        <div v-if="model" class="checkout-input__form">
          <slot name="form"></slot>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CheckoutInput',
  props: {
    name: {
      type: String,
      default: 'method',
    },
    value: {
      type: String,
      required: true,
    },
    alwaysShowDescription: Boolean,
    checked: Boolean,
    useVShow: Boolean,
  },
  data() {
    return {
      model: this.checked ? this.value : null,
    };
  },
  computed: {
    bodyClasses() {
      return [
        'checkout-input__body',
        {
          'checkout-input__body--always-show-description':
            this.alwaysShowDescription,
        },
      ];
    },
  },
  mounted() {
    const inputs = document.querySelectorAll('.checkout-input__input');

    Array.from(inputs).forEach(input =>
      input.addEventListener(
        'change',
        () =>
          (this.model =
            this.getSelectedMethod() === this.value ? this.value : null)
      )
    );
  },
  methods: {
    /**
     * @returns {string|null}
     */
    getSelectedMethod() {
      return (document.querySelector('.checkout-input__input:checked') || {})
        .value;
    },
  },
};
</script>

<style scoped lang="scss">
.checkout-input * {
  &:checked:before {
    transform: scale(0.8);
    background-color: $color-blue-dodger-blue;
    border-radius: 50%;
  }

  &:checked {
    border: 1px solid $color-blue-dodger-blue;
  }
}
</style>
